import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useSistemasDpSection } from "./use-sistemas-dp-section";
import { SistemasDpSectionView } from "./view-sistemas-dp-section";

export function SistemasDpSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useSistemasDpSection(props);

  return <SistemasDpSectionView {...vm} />;
}

export type * from "./types-sistemas-dp-section";
